
define("rv!templates/booking/hoteladestinndetails",[],function(){return { v:3,
  t:[ { t:7,
      e:"link",
      a:{ rel:"stylesheet",
        type:"text/css",
        href:"/fe/css/responsive.css?v=1006" } },
    " ",
    { t:7,
      e:"link",
      a:{ rel:"stylesheet",
        href:"https://fh-kit.com/buttons/v2/?red=cc0000∨ange=ff6000&green=3AB134",
        type:"text/css",
        media:"screen" } },
    " ",
    { t:7,
      e:"div",
      a:{ id:"hotel-details" },
      f:[ { t:4,
          f:[ { t:7,
              e:"a",
              a:{ "class":"btn btn-primary",
                href:[ "/Callcenter/findHotel.aspx?h=",
                  { t:2,
                    x:{ r:[ "data.Name" ],
                      s:"encodeURIComponent(_0)" } } ],
                style:"float: right; display: block; margin-bottom: 15px;" },
              f:[ "Edit in Admin Portal" ] } ],
          n:50,
          x:{ r:[ "provider.Adestinn",
              "data.ProviderCode",
              "inRole" ],
            s:"_0==_1&&_2(\"Admin,CallCenter\")" } },
        " ",
        { t:7,
          e:"div",
          a:{ "class":"span8" },
          f:[ { t:4,
              n:53,
              f:[ { t:8,
                  r:"carousel" } ],
              x:{ r:[ "data.Images" ],
                s:"{images:_0}" } } ] },
        " ",
        { t:7,
          e:"div",
          a:{ "class":"span4" },
          f:[ { t:7,
              e:"h3",
              f:[ { t:2,
                  r:"data.Name" } ] },
            " ",
            { t:4,
              f:[ { t:7,
                  e:"br" },
                " ",
                { t:4,
                  n:53,
                  f:[ { t:8,
                      r:"hotelRating" } ],
                  r:"data.CategoryName" },
                " ",
                { t:7,
                  e:"br" },
                " ",
                { t:7,
                  e:"br" } ],
              n:50,
              r:"data.CategoryName" },
            { t:4,
              n:51,
              f:[ { t:7,
                  e:"br" } ],
              r:"data.CategoryName" },
            " ",
            { t:7,
              e:"i",
              a:{ "class":"icon-map-marker" } },
            " ",
            { t:7,
              e:"a",
              v:{ click:"onMapClick" },
              a:{ href:"#" },
              f:[ { t:2,
                  r:"data.DisplayAddress" } ] },
            { t:7,
              e:"br" },
            " ",
            { t:7,
              e:"i",
              a:{ "class":"icon-bell" } },
            " ",
            { t:2,
              x:{ r:[ "formatPhone",
                  "data.Phone" ],
                s:"_0(_1)" } },
            { t:7,
              e:"br" },
            " ",
            { t:4,
              f:[ { t:7,
                  e:"br" },
                { t:7,
                  e:"br" },
                " ",
                { t:7,
                  e:"div",
                  a:{ "class":"well",
                    style:"float: left; width: 250px; margin-top: 10px; background-color: #fff; border-color: #ddd; font-weight: bold;" },
                  f:[ { t:7,
                      e:"img",
                      a:{ src:"https://adestinn2blob.blob.core.windows.net/images/destinationimages/page/perfectsaver_green_nospace.png?v=2",
                        alt:"PerfectSaver" } },
                    " ",
                    { t:7,
                      e:"strong",
                      f:[ { t:7,
                          e:"em",
                          f:[ "Preview" ] } ] },
                    " ",
                    { t:7,
                      e:"br" },
                    { t:7,
                      e:"br" },
                    " Get your ",
                    { t:4,
                      f:[ "up to 50%" ],
                      n:50,
                      x:{ r:[ "Settings.MatchPercentage" ],
                        s:"_0===\"Default\"" } },
                    { t:4,
                      n:51,
                      f:[ { t:2,
                          r:"Settings.MatchPercentage" } ],
                      x:{ r:[ "Settings.MatchPercentage" ],
                        s:"_0===\"Default\"" } },
                    " match working for you; ",
                    { t:7,
                      e:"span",
                      a:{ style:"font-size: 16px;" },
                      f:[ { t:2,
                          x:{ r:[ "formatMoney",
                              "data.perfectSaverAmount" ],
                            s:"_0(_1)" } } ] },
                    " per week could save enough for a ",
                    { t:7,
                      e:"span",
                      a:{ style:"text-decoration: underline; font-size: 16px;" },
                      f:[ "week's stay" ] },
                    " at this hotel. ",
                    { t:7,
                      e:"a",
                      a:{ href:"#pppreveiwExplanation",
                        "class":"infoLink",
                        "data-track":"hotel_details,perfect_saver_help,click,1" },
                      f:[ { t:7,
                          e:"img",
                          a:{ src:"https://adestinn2blob.blob.core.windows.net/images/ico-question.png",
                            alt:"What's this?" } } ] } ] },
                " ",
                { t:7,
                  e:"div",
                  a:{ id:"pppreveiwExplanation",
                    style:"display: none; width: 300px;" },
                  f:[ { t:7,
                      e:"strong",
                      f:[ "PerfectSaver",
                        { t:7,
                          e:"sup",
                          f:[ "®" ] },
                        " Preview" ] },
                    " is an example of what a 6-night stay might cost based on a weekly savings schedule with 12 months of saving. This is based on the lowest daily room rate published by Travel Weekly for this hotel and does not include any applicable fees or taxes. ",
                    { t:7,
                      e:"br" },
                    { t:7,
                      e:"br" },
                    " Get the actual cost of your stay prior to booking on the booking page. There, the number of guests, dates of stay, and room type selected give you the exact payment details. PerfectSaver will automatically calculate and display your savings options." ] } ],
              n:50,
              x:{ r:[ "data.perfectSaverAmount",
                  "isLoggedIn" ],
                s:"_0!=null&&!_1()" } },
            " ",
            { t:7,
              e:"br" },
            { t:7,
              e:"br" },
            " ",
            { t:8,
              r:"HotelNotAvailableMessage" },
            " ",
            { t:7,
              e:"br",
              a:{ "class":"clear" } },
            " ",
            { t:4,
              f:[ { t:7,
                  e:"div",
                  a:{ id:"phHotelInterest",
                    style:"display: none; margin-bottom: 15px;" },
                  f:[ { t:7,
                      e:"div",
                      a:{ id:"votePanel",
                        style:"display: none;" },
                      f:[ { t:7,
                          e:"h5",
                          a:{ style:"margin-bottom: 10px;" },
                          f:[ "This hotel is not available for booking. If you would like to receive an email as soon as the hotel is available, please click the button below." ] },
                        " ",
                        { t:7,
                          e:"button",
                          a:{ id:"btnRegisterInterest",
                            type:"button",
                            "class":"btn btn-large",
                            title:"You will receive an email when this hotel is available." },
                          f:[ { t:7,
                              e:"i",
                              a:{ "class":"icon-ok" } },
                            " ",
                            { t:7,
                              e:"h5",
                              a:{ style:"display: inline;" },
                              f:[ "Notify When Available" ] } ] } ] },
                    " ",
                    { t:7,
                      e:"div",
                      a:{ id:"alreadyVoted",
                        style:"display: none;",
                        "class":"well" },
                      f:[ { t:7,
                          e:"h5",
                          f:[ "What makes you most interested in this hotel? (optional)" ] },
                        " ",
                        { t:7,
                          e:"br" },
                        " ",
                        { t:7,
                          e:"textarea",
                          a:{ rows:"2",
                            cols:"80",
                            placeholder:"comments",
                            style:"width: 230px; height: 120px;",
                            id:"interestComment" } },
                        " ",
                        { t:7,
                          e:"br" },
                        " ",
                        { t:7,
                          e:"button",
                          a:{ id:"leaveComment",
                            "class":"btn",
                            type:"button" },
                          f:[ "Submit Comments" ] } ] },
                    " ",
                    { t:7,
                      e:"div",
                      a:{ id:"afterRegisterInterest",
                        style:"display: none;" },
                      f:[ { t:7,
                          e:"h5",
                          f:[ "You will receive an email when this hotel is available." ] },
                        " ",
                        { t:7,
                          e:"br" },
                        " ",
                        { t:7,
                          e:"a",
                          a:{ href:"#",
                            id:"editComment",
                            "class":"sideNote" },
                          f:[ "edit comment" ] } ] } ] } ],
              n:50,
              x:{ r:[ "isLoggedIn",
                  "data.ProviderCode",
                  "provider.Adestinn",
                  "data.AdestinnStatus",
                  "STATUSES.Active" ],
                s:"_0()&&_1==_2&&_3!==_4" } },
            " ",
            { t:4,
              f:[ { t:7,
                  e:"div",
                  a:{ id:"cannotBook",
                    style:"display: block; margin-bottom: 15px;" },
                  f:[ { t:7,
                      e:"h5",
                      a:{ style:"margin-bottom: 10px;" },
                      f:[ "This hotel is not available for booking. If you would like to receive an email as soon as the hotel is available, please click the button below." ] } ] } ],
              n:50,
              x:{ r:[ "isLoggedIn",
                  "data.ProviderCode",
                  "provider.Adestinn",
                  "data.AdestinnStatus",
                  "STATUSES.Active" ],
                s:"!_0()&&_1==_2&&_3!==_4" } },
            " ",
            { t:7,
              e:"a",
              a:{ "class":"btn",
                onclick:"window.location.href='/#/hotel-new-search'" },
              f:[ "Explore a Different Hotel" ] },
            " ",
            { t:7,
              e:"br" },
            { t:7,
              e:"br" },
            " ",
            { t:4,
              f:[ { t:7,
                  e:"a",
                  a:{ "class":"fh-button-green fh-icon--check",
                    href:[ "./about/fareharbor/?dest=",
                      { t:2,
                        r:"data.Region" } ],
                    target:"_blank" },
                  f:[ "Local Activities(",
                    { t:2,
                      r:"data.LocalActivities" },
                    ")" ] },
                " ",
                { t:7,
                  e:"br" } ],
              n:50,
              x:{ r:[ "data.LocalActivities" ],
                s:"_0>0" } },
            " ",
            { t:8,
              r:"VerifyEmail" },
            " ",
            { t:7,
              e:"br" } ] },
        " ",
        { t:7,
          e:"br",
          a:{ "class":"clear" } },
        " ",
        { t:7,
          e:"div",
          a:{ "class":"container-fluid" },
          f:[ { t:4,
              f:[ { t:4,
                  f:[ { t:4,
                      f:[ { t:7,
                          e:"div",
                          a:{ style:"margin-top: 20px;" },
                          f:[ { t:3,
                              r:"DetailHTML" } ] } ],
                      n:50,
                      x:{ r:[ "Description" ],
                        s:"_0===\"Hotel Overview\"" } } ],
                  n:52,
                  r:"data.Description" } ],
              n:50,
              x:{ r:[ "data.ProviderCode",
                  "provider.Adestinn" ],
                s:"_0==_1" } },
            { t:4,
              n:51,
              f:[ { t:4,
                  n:50,
                  x:{ r:[ "data.ProviderCode",
                      "provider.Hotelbeds" ],
                    s:"_0==_1" },
                  f:[ { t:7,
                      e:"h3",
                      a:{ "class":"hotel-detail-overview-heading" },
                      f:[ "Overview" ] },
                    " ",
                    { t:7,
                      e:"p",
                      a:{ "class":"hotel-detail-description" },
                      f:[ { t:2,
                          r:"data.Description" } ] },
                    " ",
                    { t:7,
                      e:"br" },
                    " ",
                    { t:7,
                      e:"h3",
                      f:[ "Highlights" ] },
                    " ",
                    { t:7,
                      e:"p",
                      a:{ "class":"hotel-detail-description" },
                      f:[ "Not all amenities and facilities are available with every room type." ] },
                    " ",
                    { t:7,
                      e:"div",
                      a:{ "class":"hotel-meta-container" },
                      f:[ { t:4,
                          f:[ { t:7,
                              e:"div",
                              a:{ "class":"hotel-facility-container" },
                              f:[ { t:7,
                                  e:"h4",
                                  a:{ "class":"hotel-facility-heading" },
                                  f:[ "Main amenities" ] },
                                " ",
                                { t:7,
                                  e:"ul",
                                  f:[ { t:4,
                                      f:[ { t:4,
                                          f:[ { t:7,
                                              e:"li",
                                              f:[ { t:8,
                                                  r:"DisplayFacilities" } ] } ],
                                          n:50,
                                          x:{ r:[ "index" ],
                                            s:"_0<6" } } ],
                                      n:52,
                                      i:"index",
                                      r:"data.Amenities" } ] } ] } ],
                          n:50,
                          x:{ r:[ "data.Amenities.length" ],
                            s:"_0>0" } },
                        " ",
                        { t:4,
                          f:[ { t:7,
                              e:"div",
                              a:{ "class":"hotel-facility-container" },
                              f:[ { t:7,
                                  e:"h4",
                                  a:{ "class":"hotel-facility-heading" },
                                  f:[ "Standard facilities" ] },
                                " ",
                                { t:7,
                                  e:"ul",
                                  f:[ { t:4,
                                      f:[ { t:4,
                                          f:[ { t:7,
                                              e:"li",
                                              f:[ { t:8,
                                                  r:"DisplayFacilities" } ] } ],
                                          n:50,
                                          x:{ r:[ "index" ],
                                            s:"_0<6" } } ],
                                      n:52,
                                      i:"index",
                                      r:"data.Facilities" } ] } ] } ],
                          n:50,
                          x:{ r:[ "data.Facilities.length" ],
                            s:"_0>0" } },
                        " ",
                        { t:4,
                          f:[ { t:7,
                              e:"div",
                              a:{ "class":"hotel-facility-container" },
                              f:[ { t:7,
                                  e:"h4",
                                  a:{ "class":"hotel-facility-heading" },
                                  f:[ "Nearby" ] },
                                " ",
                                { t:7,
                                  e:"ul",
                                  f:[ { t:4,
                                      f:[ { t:7,
                                          e:"li",
                                          f:[ { t:2,
                                              r:".Description" },
                                            " ",
                                            { t:7,
                                              e:"em",
                                              f:[ { t:2,
                                                  x:{ r:[ "metersToMiles",
                                                      "metersToFeet",
                                                      ".Distance" ],
                                                    s:"_2>0?(_2>=1000?\"(\"+_0(_2)+\" mi)\":\"(\"+_1(_2)+\" ft)\"):\"\"" } } ] } ] } ],
                                      n:52,
                                      r:"data.Nearby" } ] } ] } ],
                          n:50,
                          x:{ r:[ "data.Nearby.length" ],
                            s:"_0>0" } },
                        " ",
                        { t:4,
                          f:[ { t:7,
                              e:"div",
                              a:{ "class":"hotel-facility-container" },
                              f:[ { t:7,
                                  e:"h4",
                                  a:{ "class":"hotel-facility-heading" },
                                  f:[ "Interest points" ] },
                                " ",
                                { t:7,
                                  e:"ul",
                                  f:[ { t:4,
                                      f:[ { t:7,
                                          e:"li",
                                          f:[ { t:2,
                                              r:".PoiName" },
                                            " ",
                                            { t:7,
                                              e:"em",
                                              f:[ { t:2,
                                                  x:{ r:[ "metersToMiles",
                                                      "metersToFeet",
                                                      ".Distance" ],
                                                    s:"_2>0?(_2>=1000?\"(\"+_0(_2)+\" mi)\":\"(\"+_1(_2)+\" ft)\"):\"\"" } } ] } ] } ],
                                      n:52,
                                      r:"data.InterestPoints" } ] } ] } ],
                          n:50,
                          x:{ r:[ "data.InterestPoints.length" ],
                            s:"_0>0" } } ] },
                    " ",
                    { t:4,
                      f:[ { t:8,
                          r:"AmenityLegend" } ],
                      n:50,
                      x:{ r:[ "data.Amenities.length",
                          "data.Facilities.length" ],
                        s:"_0>0||_1>0" } },
                    " ",
                    { t:4,
                      f:[ { t:7,
                          e:"a",
                          a:{ href:"#hotelbedsFacilities",
                            "class":"btn infoLink more-highlights-link" },
                          f:[ "More Highlights" ] } ],
                      n:50,
                      x:{ r:[ "data.Amenities.length",
                          "data.Facilities.length" ],
                        s:"_0>0||_1>0" } },
                    " ",
                    { t:8,
                      r:"HotelbedsFacilities" } ] } ],
              x:{ r:[ "data.ProviderCode",
                  "provider.Adestinn" ],
                s:"_0==_1" } } ] },
        " ",
        { t:7,
          e:"br",
          a:{ "class":"clear" } },
        " ",
        { t:7,
          e:"div",
          a:{ style:"width: 100%; text-align: center; margin-top: 30px; margin-bottom: 30px;" },
          f:[ { t:8,
              r:"HotelNotAvailableMessage" },
            " ",
            { t:8,
              r:"ViewAvailabilityButton" } ] },
        " ",
        { t:7,
          e:"div",
          a:{ "class":"container-fluid",
            style:"text-align: center; margin-bottom: 30px;" },
          f:[ "* This information is provided as a courtesy and is subject to change, by the property, without notice to Adestinn or its members. Adestinn is not responsible for information presented here that is no longer current. It is up to each member to verify with the property any details that are important to their stay." ] },
        " ",
        { t:7,
          e:"div",
          a:{ "class":"container-fluid",
            style:"text-align: center; margin-bottom: 30px;" },
          f:[ { t:4,
              f:[ { t:4,
                  n:53,
                  f:[ { t:8,
                      r:"ManualBookingForm" } ],
                  x:{ r:[ "data",
                      "onManualBook",
                      "isDba",
                      "updateManualBooking",
                      "isManualFormValid" ],
                    s:"{data:_0,onManualBook:_1,isDba:_2,updateManualBooking:_3,isManualFormValid:_4}" } } ],
              n:50,
              x:{ r:[ "provider.Hotelbeds",
                  "isDba",
                  "data.ProviderCode",
                  "provider.Adestinn",
                  "data.AdestinnStatus",
                  "STATUSES.Active" ],
                s:"_2==_0||(_1||(_2==_3&&_4===_5))" } },
            " ",
            { t:4,
              f:[ { t:4,
                  f:[ { t:4,
                      n:53,
                      f:[ { t:8,
                          r:"messenger" } ],
                      r:"messenger" },
                    " ",
                    { t:4,
                      f:[ { t:7,
                          e:"div",
                          a:{ style:"text-align: center;" },
                          f:[ { t:7,
                              e:"img",
                              a:{ id:"homeLoadIMG",
                                src:"https://adestinn2blob.blob.core.windows.net/images/loading12102015-2.gif" } } ] } ],
                      n:50,
                      r:"loadingResults" },
                    { t:4,
                      n:51,
                      f:[ { t:4,
                          n:53,
                          f:[ { t:8,
                              r:"availableRoomList" } ],
                          x:{ r:[ "availability",
                              "togglePriceDetails",
                              "getPerfectSaverMessage" ],
                            s:"{availability:_0,togglePriceDetails:_1,getPerfectSaverMessage:_2}" } } ],
                      r:"loadingResults" } ],
                  n:50,
                  r:"data.user.EmailVerified" },
                { t:4,
                  n:51,
                  f:[ { t:8,
                      r:"VerifyEmail" } ],
                  r:"data.user.EmailVerified" } ],
              n:50,
              x:{ r:[ "isLoggedIn",
                  "provider.Hotelbeds",
                  "isDba",
                  "data.ProviderCode",
                  "provider.Adestinn",
                  "data.AdestinnStatus",
                  "STATUSES.Active" ],
                s:"_0()&&(_3==_1||(_2||(_3==_4&&_5===_6)))" } } ] },
        " ",
        { t:7,
          e:"button",
          a:{ type:"button",
            "class":"scroll-to-top-button",
            onclick:"window.scrollTo({top: 0, behavior: \"smooth\"});" },
          f:[ { t:7,
              e:"svg",
              a:{ xmlns:"http://www.w3.org/2000/svg",
                width:"30",
                height:"30",
                fill:"currentColor",
                "class":"bi bi-arrow-up-short",
                viewBox:"0 0 16 16" },
              f:[ { t:7,
                  e:"path",
                  a:{ "fill-rule":"evenodd",
                    d:"M8 12a.5.5 0 0 0 .5-.5V5.707l2.146 2.147a.5.5 0 0 0 .708-.708l-3-3a.5.5 0 0 0-.708 0l-3 3a.5.5 0 1 0 .708.708L7.5 5.707V11.5a.5.5 0 0 0 .5.5z" } } ] } ] } ] },
    " ",
    { t:7,
      e:"div",
      a:{ id:"google-map-dialog",
        "class":"modal fade",
        role:"dialog" },
      f:[ { t:7,
          e:"div",
          a:{ "class":"modal-dialog" },
          f:[ { t:7,
              e:"div",
              a:{ "class":"modal-content" },
              f:[ { t:7,
                  e:"div",
                  a:{ "class":"modal-header" },
                  f:[ { t:7,
                      e:"button",
                      a:{ type:"button",
                        "class":"close" },
                      v:{ click:"onCloseMap" },
                      f:[ { t:7,
                          e:"span",
                          a:{ "aria-hidden":"true" },
                          f:[ "×" ] } ] },
                    " ",
                    { t:7,
                      e:"h4",
                      a:{ "class":"modal-title" },
                      f:[ " " ] } ] },
                " ",
                { t:7,
                  e:"div",
                  a:{ "class":"modal-body",
                    id:"google-map" } } ] } ] } ] } ],
  p:{ HotelNotAvailableMessage:[ { t:4,
        f:[ { t:7,
            e:"h5",
            f:[ { t:4,
                f:[ "This hotel is no longer available to book." ],
                n:50,
                x:{ r:[ "data.AdestinnStatus",
                    "STATUSES.NoLongerActive" ],
                  s:"_0===_1" } },
              { t:4,
                n:51,
                f:[ "Coming Soon!" ],
                x:{ r:[ "data.AdestinnStatus",
                    "STATUSES.NoLongerActive" ],
                  s:"_0===_1" } } ] } ],
        n:50,
        x:{ r:[ "data.ProviderCode",
            "provider.Adestinn",
            "STATUSES.LikelyToParticipate",
            "data.AdestinnStatus",
            "STATUSES.NoLongerActive" ],
          s:"_0==_1&&_3===_2||_3===_4" } } ],
    DisplayFacilities:[ { t:2,
        r:".Description" },
      " ",
      { t:4,
        f:[ { t:2,
            r:".DateFrom" } ],
        n:50,
        x:{ r:[ ".DateFrom" ],
          s:"_0!=\"\"" } },
      { t:4,
        n:51,
        f:[ { t:4,
            n:50,
            x:{ r:[ ".DateTo" ],
              s:"_0!=\"\"" },
            f:[ { t:2,
                r:".DateTo" } ] },
          { t:4,
            n:50,
            x:{ r:[ ".DateTo",
                ".Distance" ],
              s:"(!(_0!=\"\"))&&(_1!=\"0\")" },
            f:[ " ",
              { t:2,
                r:".Distance" } ] },
          { t:4,
            n:50,
            x:{ r:[ ".DateTo",
                ".Distance",
                ".TimeFrom" ],
              s:"(!(_0!=\"\"))&&((!(_1!=\"0\"))&&(_2!=\"\"))" },
            f:[ " ",
              { t:2,
                x:{ r:[ ".TimeFrom" ],
                  s:"_0.replace(/\\d+\\/\\d+\\/\\d{4}/,\"\")" } } ] },
          { t:4,
            n:50,
            x:{ r:[ ".DateTo",
                ".Distance",
                ".TimeFrom",
                ".TimeTo" ],
              s:"(!(_0!=\"\"))&&((!(_1!=\"0\"))&&((!(_2!=\"\"))&&(_3!=\"\")))" },
            f:[ " ",
              { t:2,
                x:{ r:[ ".TimeTo" ],
                  s:"_0.replace(/\\d+\\/\\d+\\/\\d{4}/,\"\")" } } ] } ],
        x:{ r:[ ".DateFrom" ],
          s:"_0!=\"\"" } },
      " ",
      { t:4,
        f:[ "- ",
          { t:2,
            r:".FeeSymbol" } ],
        n:50,
        x:{ r:[ ".FeeSymbol" ],
          s:"_0!=\"\"" } } ],
    AmenityLegend:[ { t:7,
        e:"div",
        a:{ "class":"hotel-facility-container facility-legend-container" },
        f:[ { t:7,
            e:"h5",
            f:[ "Legend" ] },
          " ",
          { t:7,
            e:"ul",
            a:{ "class":"facility-legend" },
            f:[ { t:7,
                e:"li",
                f:[ "$$: Additional cost associated - not included with room." ] },
              " " ] } ] } ],
    HotelbedsFacilities:[ { t:7,
        e:"div",
        a:{ id:"hotelbedsFacilities",
          "class":"hotel-meta-container infoBox" },
        f:[ { t:4,
            f:[ { t:8,
                r:"AmenityLegend" } ],
            n:50,
            x:{ r:[ "data.Amenities.length",
                "data.Facilities.length" ],
              s:"_0>0||_1>0" } },
          " ",
          { t:4,
            f:[ { t:7,
                e:"div",
                a:{ "class":"hotel-facility-container" },
                f:[ { t:7,
                    e:"h3",
                    a:{ "class":"hotel-facility-heading" },
                    f:[ "Main amenities" ] },
                  " ",
                  { t:7,
                    e:"ul",
                    f:[ { t:4,
                        f:[ { t:7,
                            e:"li",
                            f:[ { t:8,
                                r:"DisplayFacilities" } ] } ],
                        n:52,
                        r:"data.Amenities" } ] } ] } ],
            n:50,
            x:{ r:[ "data.Amenities.length" ],
              s:"_0>0" } },
          " ",
          { t:4,
            f:[ { t:7,
                e:"div",
                a:{ "class":"hotel-facility-container" },
                f:[ { t:7,
                    e:"h3",
                    a:{ "class":"hotel-facility-heading" },
                    f:[ "Standard facilities" ] },
                  " ",
                  { t:7,
                    e:"ul",
                    f:[ { t:4,
                        f:[ { t:7,
                            e:"li",
                            f:[ { t:8,
                                r:"DisplayFacilities" } ] } ],
                        n:52,
                        r:"data.Facilities" } ] } ] } ],
            n:50,
            x:{ r:[ "data.Facilities.length" ],
              s:"_0>0" } },
          " ",
          { t:4,
            f:[ { t:7,
                e:"div",
                a:{ "class":"hotel-facility-container" },
                f:[ { t:7,
                    e:"h3",
                    a:{ "class":"hotel-facility-heading" },
                    f:[ "Nearby" ] },
                  " ",
                  { t:7,
                    e:"ul",
                    f:[ { t:4,
                        f:[ { t:7,
                            e:"li",
                            f:[ { t:2,
                                r:".Description" },
                              " ",
                              { t:7,
                                e:"em",
                                f:[ { t:2,
                                    x:{ r:[ "metersToMiles",
                                        "metersToFeet",
                                        ".Distance" ],
                                      s:"_2>0?(_2>=1000?\"(\"+_0(_2)+\" mi)\":\"(\"+_1(_2)+\" ft)\"):\"\"" } } ] } ] } ],
                        n:52,
                        r:"data.Nearby" } ] } ] } ],
            n:50,
            x:{ r:[ "data.Nearby.length" ],
              s:"_0>0" } },
          " ",
          { t:4,
            f:[ { t:7,
                e:"div",
                a:{ "class":"hotel-facility-container" },
                f:[ { t:7,
                    e:"h3",
                    a:{ "class":"hotel-facility-heading" },
                    f:[ "Interest points" ] },
                  " ",
                  { t:7,
                    e:"ul",
                    f:[ { t:4,
                        f:[ { t:7,
                            e:"li",
                            f:[ { t:2,
                                r:".PoiName" },
                              " ",
                              { t:7,
                                e:"em",
                                f:[ { t:2,
                                    x:{ r:[ "metersToMiles",
                                        "metersToFeet",
                                        ".Distance" ],
                                      s:"_2>0?(_2>=1000?\"(\"+_0(_2)+\" mi)\":\"(\"+_1(_2)+\" ft)\"):\"\"" } } ] } ] } ],
                        n:52,
                        r:"data.InterestPoints" } ] } ] } ],
            n:50,
            x:{ r:[ "data.InterestPoints.length" ],
              s:"_0>0" } } ] } ],
    ViewAvailabilityButton:[ { t:4,
        f:[ { t:7,
            e:"a",
            a:{ href:[ "/hotel/?hotel=",
                { t:2,
                  r:"data.HotelID" } ],
              "class":"btn btn-primary btn-large" },
            f:[ "Enter" ] } ],
        n:50,
        r:"hotelPortalUser" },
      { t:4,
        n:51,
        f:[ { t:4,
            n:50,
            x:{ r:[ "isLoggedIn" ],
              s:"!_0()" },
            f:[ { t:7,
                e:"a",
                a:{ style:"margin-top: 10px;",
                  "class":"btn btn-large btn-primary" },
                v:{ click:"loginToViewAvailability" },
                f:[ { t:7,
                    e:"strong",
                    f:[ "Login to View Availability" ] } ] } ] },
          { t:4,
            n:50,
            x:{ r:[ "isLoggedIn" ],
              s:"(_0())&&(_0())" },
            f:[ " ",
              { t:4,
                f:[ { t:7,
                    e:"div",
                    a:{ "class":"container" },
                    f:[ { t:7,
                        e:"div",
                        f:[ { t:7,
                            e:"h2",
                            a:{ style:"text-align: left; padding-left: 20px; margin-bottom: 20px;" },
                            f:[ "Room Selection" ] } ] },
                      " ",
                      { t:7,
                        e:"div",
                        a:{ "class":"well hotel-availability-form",
                          style:"margin-left: 20px; margin-right: 20px; padding-top: 10px; padding-bottom: 10px; margin-bottom: 0;" },
                        f:[ { t:7,
                            e:"div",
                            a:{ style:"text-align: left; padding-left: 10px;",
                              "class":"row" },
                            f:[ { t:7,
                                e:"div",
                                a:{ "class":"span4_dates" },
                                f:[ { t:7,
                                    e:"div",
                                    a:{ style:"margin-top: 10px;" },
                                    f:[ { t:7,
                                        e:"i",
                                        a:{ "class":"icon-calendar" } },
                                      "  ",
                                      { t:7,
                                        e:"strong",
                                        f:[ "Arrive / Depart" ] } ] },
                                  " ",
                                  { t:7,
                                    e:"div",
                                    a:{ "class":"row" },
                                    f:[ { t:7,
                                        e:"div",
                                        a:{ "class":"span12_mobile_from_date" },
                                        f:[ { t:7,
                                            e:"label",
                                            a:{ "for":"fromDate",
                                              id:"fromDateLabel",
                                              "class":"from_date_label_responsive" },
                                            f:[ "From:" ] },
                                          " ",
                                          { t:7,
                                            e:"input",
                                            a:{ type:"date",
                                              "class":"search-changeable",
                                              id:"fromDate",
                                              style:"width: 115px; margin-top: 8px; margin-left: 5px;",
                                              value:[ { t:2,
                                                  r:"data.planningData.Timeline.FromDate" } ] } } ] },
                                      " ",
                                      { t:7,
                                        e:"div",
                                        a:{ "class":"span12_mobile" },
                                        f:[ { t:7,
                                            e:"label",
                                            a:{ "for":"toDate",
                                              id:"toDateLabel",
                                              "class":"toDateLabelResponsive" },
                                            f:[ "To:" ] },
                                          " ",
                                          { t:7,
                                            e:"input",
                                            a:{ type:"date",
                                              "class":"search-changeable",
                                              id:"toDate",
                                              style:"width: 115px; margin-top: 8px; margin-left: 5px;",
                                              value:[ { t:2,
                                                  r:"data.planningData.Timeline.ToDate" } ] } } ] },
                                      " ",
                                      { t:4,
                                        f:[ { t:7,
                                            e:"div",
                                            a:{ style:"margin-bottom: 4px;" },
                                            f:[ "Minimum Stay: ",
                                              { t:7,
                                                e:"strong",
                                                f:[ { t:2,
                                                    r:"data.hotel.MinStayRange" } ] } ] } ],
                                        n:50,
                                        x:{ r:[ "data.MinStayRange" ],
                                          s:"_0!=null" } } ] },
                                  " ",
                                  { t:4,
                                    f:[ { t:7,
                                        e:"div",
                                        a:{ style:"text-align: left; margin-bottom: 10px; margin-top: 5px;" },
                                        f:[ { t:7,
                                            e:"input",
                                            a:{ id:"chkShowGDSData",
                                              type:"checkbox",
                                              autocomplete:"off",
                                              checked:[ { t:2,
                                                  r:"showGdsData" } ] } },
                                          " ",
                                          { t:7,
                                            e:"label",
                                            a:{ "for":"chkShowGDSData" },
                                            f:[ "Show GDS Room Descriptions" ] } ] } ],
                                    n:50,
                                    r:"isDba" } ] },
                              " ",
                              { t:7,
                                e:"div",
                                a:{ "class":"span4_2" },
                                f:[ { t:7,
                                    e:"div",
                                    a:{ style:"margin-top: 10px;" },
                                    f:[ { t:7,
                                        e:"i",
                                        a:{ "class":"icon-user" } },
                                      "  ",
                                      { t:7,
                                        e:"strong",
                                        f:[ "Travelers" ] } ] },
                                  " ",
                                  { t:7,
                                    e:"div",
                                    a:{ style:"position: relative;" },
                                    f:[ { t:7,
                                        e:"button",
                                        a:{ "class":"search-changeable",
                                          style:"margin-right: 20px; margin-top: 8px; margin-bottom: 8px;",
                                          id:"hotelGuestsButton" },
                                        f:[ { t:2,
                                            r:"data.planningData.TravelerInfo.AdultCount" },
                                          " ",
                                          { t:2,
                                            r:"adultTag" },
                                          { t:4,
                                            f:[ ", ",
                                              { t:2,
                                                r:"data.planningData.TravelerInfo.ChildCount" },
                                              " ",
                                              { t:2,
                                                r:"childTag" } ],
                                            n:50,
                                            x:{ r:[ "data.planningData.TravelerInfo.ChildCount" ],
                                              s:"_0>0" } } ] },
                                      " ",
                                      { t:7,
                                        e:"div",
                                        a:{ "class":"hotel-guest-inputs-container hotel-availability-triangle",
                                          style:"right: 50px; top: 40px;" },
                                        f:[ { t:7,
                                            e:"label",
                                            a:{ "for":"adultNumber",
                                              id:"adultNumberLabel" },
                                            f:[ "Adults:" ] },
                                          " ",
                                          { t:7,
                                            e:"input",
                                            a:{ type:"number",
                                              "class":"search-changeable",
                                              id:"adultNumber",
                                              min:"1",
                                              max:"10",
                                              value:[ { t:2,
                                                  r:"data.planningData.TravelerInfo.AdultCount" } ] } },
                                          " ",
                                          { t:7,
                                            e:"label",
                                            a:{ "for":"childrenNumber",
                                              id:"childrenNumberLabel" },
                                            f:[ "Children:" ] },
                                          " ",
                                          { t:7,
                                            e:"input",
                                            a:{ type:"number",
                                              "class":"search-changeable",
                                              id:"childrenNumber",
                                              min:"0",
                                              max:"10",
                                              value:[ { t:2,
                                                  r:"data.planningData.TravelerInfo.ChildCount" } ] } },
                                          " ",
                                          { t:7,
                                            e:"div",
                                            a:{ id:"childAgeInput" },
                                            f:[  ] } ] } ] } ] },
                              " ",
                              { t:4,
                                f:[ { t:7,
                                    e:"div",
                                    a:{ "class":"span4_co_traveler" },
                                    f:[ { t:7,
                                        e:"div",
                                        a:{ style:"text-align: left; margin-top: 10px;" },
                                        f:[ { t:7,
                                            e:"strong",
                                            f:[ "What name is this reservation under?" ] },
                                          " ",
                                          { t:7,
                                            e:"br" },
                                          " ",
                                          { t:4,
                                            f:[ { t:7,
                                                e:"label",
                                                f:[ { t:7,
                                                    e:"input",
                                                    v:{ change:"clearRooms" },
                                                    a:{ id:"member-book",
                                                      "class":"travel-member-changeable",
                                                      type:"radio",
                                                      name:[ { t:2,
                                                          r:"data.planningData.TravelerInfo.CoMemberBook" } ],
                                                      value:"false" } },
                                                  " ",
                                                  { t:2,
                                                    r:"data.user.NameFirst" },
                                                  " ",
                                                  { t:2,
                                                    r:"data.user.NameLast" } ] },
                                              " ",
                                              { t:7,
                                                e:"br" } ],
                                            n:50,
                                            x:{ r:[ "isMAW" ],
                                              s:"!_0" } },
                                          " ",
                                          { t:7,
                                            e:"label",
                                            f:[ { t:7,
                                                e:"input",
                                                v:{ change:"clearRooms" },
                                                a:{ id:"co-member-book",
                                                  "class":"travel-member-changeable",
                                                  type:"radio",
                                                  name:[ { t:2,
                                                      r:"data.planningData.TravelerInfo.CoMemberBook" } ],
                                                  value:"true" },
                                                m:[ { t:4,
                                                    f:[ "checked=\"checked\"" ],
                                                    n:50,
                                                    r:"isMAW" } ] },
                                              " ",
                                              { t:4,
                                                f:[ " ",
                                                  { t:7,
                                                    e:"input",
                                                    a:{ type:"text",
                                                      name:"altName",
                                                      id:"alt-member-name-book",
                                                      "class":"travel-member-changeable",
                                                      value:[ { t:2,
                                                          r:"data.planningData.TravelerInfo.CoMemberAltName" } ],
                                                      placeholder:"Enter onetime booking name",
                                                      style:"width: 175px;" },
                                                    v:{ change:"clearRooms" } },
                                                  " ",
                                                  { t:7,
                                                    e:"br" },
                                                  "       ",
                                                  { t:7,
                                                    e:"strong",
                                                    f:[ "Default:" ] },
                                                  " ",
                                                  { t:2,
                                                    r:"data.user.CoTraveler" } ],
                                                n:50,
                                                x:{ r:[ "isDba",
                                                    "isMAW" ],
                                                  s:"_0||_1" } },
                                              { t:4,
                                                n:51,
                                                f:[ { t:2,
                                                    r:"data.user.CoTraveler" } ],
                                                x:{ r:[ "isDba",
                                                    "isMAW" ],
                                                  s:"_0||_1" } } ] } ] },
                                      " ",
                                      { t:7,
                                        e:"div",
                                        a:{ style:"margin-top: 20px;" },
                                        f:[ { t:7,
                                            e:"strong",
                                            f:[ "Phone" ] },
                                          " ",
                                          { t:7,
                                            e:"br" },
                                          " ",
                                          { t:7,
                                            e:"input",
                                            a:{ type:"text",
                                              value:[ { t:2,
                                                  r:"data.user.Phone" } ],
                                              id:"userPhoneNumber",
                                              "class":"span4_phoneInput" },
                                            v:{ change:"onPhoneChange" } } ] } ] } ],
                                n:50,
                                r:"showCoTraveler" },
                              { t:4,
                                n:51,
                                f:[ { t:7,
                                    e:"div",
                                    a:{ "class":"span4_co_traveler" },
                                    f:[ { t:7,
                                        e:"div",
                                        a:{ style:"text-align: left; margin-top: 10px;" },
                                        f:[ { t:7,
                                            e:"strong",
                                            f:[ "Phone" ] },
                                          " ",
                                          { t:7,
                                            e:"br" },
                                          " ",
                                          { t:7,
                                            e:"div",
                                            f:[ { t:7,
                                                e:"input",
                                                a:{ type:"text",
                                                  value:[ { t:2,
                                                      r:"data.user.Phone" } ],
                                                  id:"userPhoneNumber",
                                                  "class":"span4_phoneInput" },
                                                v:{ change:"onPhoneChange" } } ] } ] } ] } ],
                                r:"showCoTraveler" },
                              " ",
                              { t:7,
                                e:"div",
                                a:{ "class":"span12_check_availability" },
                                f:[ { t:7,
                                    e:"button",
                                    a:{ "class":"btn btn-primary btn-large",
                                      style:"margin-top: 3px; font-weight: bold;" },
                                    v:{ click:"fetchRooms" },
                                    m:[ { t:4,
                                        f:[ "disabled" ],
                                        n:50,
                                        r:"loadingResults" } ],
                                    f:[ "Check Availability" ] } ] } ] } ] } ] } ],
                n:50,
                x:{ r:[ "provider.Hotelbeds",
                    "isDba",
                    "data.ProviderCode",
                    "provider.Adestinn",
                    "data.AdestinnStatus",
                    "STATUSES.Active" ],
                  s:"_2==_0||(_1||(_2==_3&&_4===_5))" } } ] } ],
        r:"hotelPortalUser" } ],
    VerifyEmail:[ { t:4,
        f:[ { t:7,
            e:"div",
            a:{ style:"margin-top: 10px;" },
            f:[ { t:7,
                e:"div",
                a:{ "class":"alert alert-info emailCheckMsg",
                  style:"margin-bottom: 10px;" },
                f:[ "To check availability, verify your email" ] },
              " ",
              { t:7,
                e:"input",
                a:{ type:"button",
                  value:"Verify Email",
                  "class":"btn btnCheckEmail btn-primary btn-large" } },
              " ",
              { t:7,
                e:"img",
                a:{ alt:"Sending Email...",
                  "class":"loadingEmailCheck",
                  style:"display: none; height: 20px; width: 20px;",
                  src:"https://adestinn2blob.blob.core.windows.net/images/loading.gif" } } ] } ],
        n:50,
        x:{ r:[ "isLoggedIn",
            "data.user.EmailVerified" ],
          s:"_0()&&!_1" } } ] } };});
